import React, { useState } from "react";
import "../../AdminDashboard/createaccount/create.css";
import { postWithoutTokenAPI } from '../../utils/Api';
import { useNavigate } from "react-router-dom";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

const CreateAccount = () => {
  const navigate = useNavigate();
  const [phonenumber, setPhonenumber] = useState("");
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [error, setError] = useState("");

  // Regex for validating phone number format (10-15 digits)
  const validatePhoneNumber = (number) => /^[0-9]{10,15}$/.test(number);

  const handleSubmit = async () => {
    setError(""); // Clear any previous errors

    // Check if phone number is provided
    if (!phonenumber) {
      setError("Phone number is required.");
      return;
    }

    // Validate the phone number format
    if (!validatePhoneNumber(phonenumber)) {
      setError("Please enter a valid phone number with Country code");
      return;
    }

    // Check if the terms and conditions are accepted
    if (!termsAccepted) {
      setError("You must accept the terms and conditions.");
      return;
    }

    try {
      const response = await postWithoutTokenAPI("/auth/otpsend", {
        phone_number: phonenumber,
      });

      if (response.statusCode === 200) {
        // toast.success("OTP sent successfully!");
        setTimeout(() => {
          navigate("/admin/Verify", {
            state: {
              phone_number: phonenumber,
              fromForgotPassword: false,
            },
          });
        }, 500);
      }  else {
        setError(response.message || "Request failed.");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    }
  };

  return (
    <div className="auth-box">
      {/* <ToastContainer autoClose={5000} /> */}
      <h2 className="auth-title">Create Account</h2>
      <div className="auth-field">
        <input
          className="auth-input"
          type="text"
          placeholder="Enter your phone number"
          value={phonenumber}
          onChange={(e) => setPhonenumber(e.target.value)}
        />
      </div>
      <div className="auth-links">
        <div className="auth-remember-section">
          <input
            type="checkbox"
            id="remember"
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
          />
          <label htmlFor="remember" className="auth-remember-label">
            Accept all terms & Conditions
          </label>
        </div>
      </div>
      {error && <div className="auth-error">{error}</div>}
      <button className="auth-button" onClick={handleSubmit}>
        Create Account
      </button>
      <div className="auth-signup-link">
        <span>Already have an account?</span>
        <a href="/login">Login</a>
      </div>
    </div>
  );
};

export default CreateAccount;
